import { useTemplateStore } from '@/stores/template';
import type { PreloadHandler } from '@/types/router';

export const preloadTemplates: PreloadHandler = async () => {
  const { getAllTemplates } = useTemplateStore();

  await getAllTemplates();
};
